export default __webpack_public_path__ + "static/rovo-menu-do-dark-10efbbcf8d2521edc4dd25c9a2cdc1427ea5b73aa09e61c6e9cd67b8883b92cc.png";